import type customersEn from "./customers.en";

const customersAr: Record<keyof typeof customersEn, string> = {
  "nav.segments": "الشرائح",
  "nav.privacy_requests": "طلبات الخصوصية",
  "common.edit": "تعديل",
  "settings.customer_accounts": "حسابات العملاء",
  "settings.customer_accounts_hint": "كيف يسجّل المتسوقون الدخول إلى متجرك",

  "cust.title": "العملاء",
  "cust.all": "الكل",
  "cust.add": "إضافة عميل",
  "cust.import": "استيراد",
  "cust.export": "تصدير",
  "cust.search": "ابحث بالاسم أو البريد أو الهاتف",
  "cust.count": "{n} عميل",
  "cust.none_match": "لا يوجد عملاء يطابقون هذه الفلاتر.",
  "cust.empty_title": "كل من يتسوق منك في مكان واحد",
  "cust.empty_body": "يظهر العملاء هنا عند إتمام الشراء أو إنشاء حساب. يمكنك أيضًا إضافتهم بنفسك أو استيراد جدول بيانات.",
  "cust.no_name": "بدون اسم",
  "cust.filter.tag": "الوسم",
  "cust.filter.email": "اشتراك البريد",
  "cust.filter.state": "الحساب",
  "cust.col.name": "العميل",
  "cust.col.subscription": "اشتراك البريد",
  "cust.col.location": "الموقع",
  "cust.col.orders": "الطلبات",
  "cust.col.spent": "المبلغ المنفق",
  "cust.sort.-created_at": "الأحدث",
  "cust.sort.created_at": "الأقدم",
  "cust.sort.-updated_at": "المحدّث مؤخرًا",
  "cust.sort.name": "الاسم أ–ي",
  "cust.sort.-amount_spent": "الأعلى إنفاقًا",
  "cust.sort.-orders_count": "الأكثر طلبات",
  "cust.sub.subscribed": "مشترك",
  "cust.sub.not_subscribed": "غير مشترك",
  "cust.sub.pending": "بانتظار التأكيد",
  "cust.sub.unsubscribed": "ألغى الاشتراك",
  "cust.state.enabled": "حساب نشط",
  "cust.state.disabled": "معطّل",
  "cust.state.invited": "مدعو",
  "cust.state.declined": "رفض الدعوة",
  "cust.channel.email": "البريد الإلكتروني",
  "cust.channel.sms": "الرسائل النصية",
  "cust.channel.whatsapp": "واتساب",
  "cust.src.checkout": "إتمام الشراء",
  "cust.src.account": "حساب العميل",
  "cust.src.admin": "لوحة الإدارة",
  "cust.src.import": "استيراد",
  "cust.src.form": "نموذج اشتراك",
  "cust.src.merge": "دمج",
  "cust.src.api": "واجهة برمجية",

  "cust.new_title": "عميل جديد",
  "cust.overview": "نظرة عامة على العميل",
  "cust.first_name": "الاسم الأول",
  "cust.last_name": "اسم العائلة",
  "cust.email": "البريد الإلكتروني",
  "cust.phone": "الهاتف",
  "cust.phone_hint": "الأرقام المحلية تستخدم رمز دولة متجرك.",
  "cust.language": "اللغة",
  "cust.language_store": "لغة المتجر",
  "cust.consent_email": "وافق العميل على تلقي رسائل تسويقية بالبريد",
  "cust.consent_sms": "وافق العميل على تلقي رسائل تسويقية نصية",
  "cust.consent_note": "لا تحدد هذه الخيارات إلا بإذن من العميل. تُسجَّل تغييرات الموافقة.",
  "cust.address": "العنوان",
  "cust.add_address": "إضافة عنوان",
  "cust.address_optional": "اختياري. يمكن للعملاء إضافة العناوين عند إتمام الشراء.",
  "cust.tags": "الوسوم",
  "cust.notes": "ملاحظات",
  "cust.notes_placeholder": "يراها الموظفون فقط.",

  "cust.since": "أُضيف {when}",
  "cust.more": "إجراءات أخرى",
  "cust.pii_masked": "بيانات الاتصال مخفية. اطلب من مالك المتجر صلاحية عرض بيانات اتصال العملاء.",
  "cust.erased_banner": "حُذفت البيانات الشخصية لهذا العميل في {date}. تبقى طلباته في سجلاتك.",
  "cust.stat.spent": "المبلغ المنفق",
  "cust.stat.orders": "الطلبات",
  "cust.stat.aov": "متوسط الطلب",
  "cust.stat.last_order": "آخر طلب",
  "cust.orders": "الطلبات",
  "cust.no_orders": "لا طلبات بعد",
  "cust.no_orders_body": "ستظهر طلبات هذا العميل هنا.",
  "cust.contact": "بيانات الاتصال",
  "cust.no_email": "لا يوجد بريد",
  "cust.no_phone": "لا يوجد هاتف",
  "cust.edit_contact": "تعديل بيانات الاتصال",
  "cust.default_address": "العنوان الافتراضي",
  "cust.addresses": "العناوين",
  "cust.manage": "إدارة",
  "cust.no_address": "لا يوجد عنوان محفوظ.",
  "cust.more_addresses": "+{n} أخرى",
  "cust.edit_address": "تعديل العنوان",
  "cust.make_default": "تعيين كافتراضي",
  "cust.default": "افتراضي",
  "cust.delete_address": "حذف هذا العنوان؟",
  "cust.marketing": "التسويق",
  "cust.history": "السجل",
  "cust.subscribe": "اشتراك",
  "cust.unsubscribe": "إلغاء الاشتراك",
  "cust.consent_confirm_title": "هل وافق العميل؟",
  "cust.consent_confirm_body": "لا تشترك إلا العملاء الذين أذنوا لك بإرسال رسائل تسويقية. يُسجَّل التغيير في سجل موافقاتهم.",
  "cust.consent_history": "سجل الموافقات",
  "cust.no_consents": "لا توجد تغييرات مسجلة.",
  "cust.when": "التاريخ",
  "cust.change": "التغيير",
  "cust.source": "المصدر",
  "cust.tax": "الضرائب",
  "cust.tax_exempt": "عدم تحصيل ضريبة من هذا العميل",
  "cust.exemption_codes": "رموز الإعفاء",
  "cust.duplicates": "تكرارات محتملة",
  "cust.duplicates_hint": "يبدو أن هؤلاء العملاء هم الشخص نفسه. ادمجهم للاحتفاظ بسجل واحد.",
  "cust.dup.same_email": "صندوق البريد نفسه",
  "cust.dup.same_phone": "رقم الهاتف نفسه",
  "cust.dup.similar_name_same_address": "اسم مشابه والعنوان نفسه",
  "cust.timeline": "السجل الزمني",
  "cust.comment_placeholder": "اكتب تعليقًا…",
  "cust.comment_hint": "يرى التعليقات الموظفون فقط.",
  "cust.post": "نشر",
  "cust.staff": "موظف",
  "cust.edited": "معدّل",
  "cust.delete_comment": "حذف هذا التعليق؟",

  "cust.send_invite": "إرسال دعوة الحساب",
  "cust.invite_title": "إرسال دعوة لإنشاء حساب؟",
  "cust.invite_body": "سنرسل إلى {email} رابطًا لتفعيل الحساب.",
  "cust.invite_sent": "أُرسلت الدعوة.",
  "cust.disable": "تعطيل الحساب",
  "cust.enable": "تفعيل الحساب",
  "cust.disable_title": "تعطيل هذا الحساب؟",
  "cust.disable_body": "سيُسجَّل خروج العميل من كل الأجهزة ولن يتمكن من الدخول حتى تعيد تفعيل الحساب. لا تتأثر طلباته.",
  "cust.data_export": "تصدير بيانات العميل",
  "cust.data_export_title": "تصدير بيانات هذا العميل؟",
  "cust.data_export_body": "سنجهز ملفًا بكل ما هو محفوظ عن هذا العميل. يمكنك تنزيله من بطاقة الخصوصية لمدة 24 ساعة.",
  "cust.data_export_started": "جارٍ تجهيز التصدير…",
  "cust.erase": "حذف البيانات الشخصية",
  "cust.erase_title": "حذف البيانات الشخصية لـ {name}؟",
  "cust.erase_body": "يُحذف الاسم وبيانات الاتصال والعناوين والملاحظات وبيانات الدخول نهائيًا. تبقى الطلبات لأغراض المحاسبة بدون بيانات شخصية. لا يمكن التراجع.",
  "cust.erased": "حُذفت البيانات الشخصية.",
  "cust.delete": "حذف العميل",
  "cust.delete_title": "حذف {name}؟",
  "cust.delete_body": "سيُحذف العميل من متجرك. لا يمكن حذف العملاء الذين لديهم طلبات؛ احذف بياناتهم الشخصية بدلًا من ذلك.",
  "cust.deleted": "حُذف العميل.",

  "cust.import_title": "استيراد العملاء",
  "cust.import_hint": "ارفع ملف CSV للعملاء بصيغة التصدير المعتادة في معظم منصات التجارة الإلكترونية. يحتاج كل صف إلى بريد إلكتروني أو رقم هاتف.",
  "cust.import_rows": "{n} صف",
  "cust.import_update": "تحديث العملاء الموجودين (المطابقة بالبريد أو الهاتف)",
  "cust.export_title": "تصدير العملاء",
  "cust.export_all": "كل العملاء",
  "cust.export_filtered": "العملاء المطابقون للفلاتر ({n})",
  "cust.export_note": "بدون صلاحية عرض بيانات الاتصال تُخفى عناوين البريد والهواتف. يتطلب تصدير أكثر من 1,000 عميل تأكيد هويتك.",
  "cust.export_ready": "التصدير جاهز. يعمل الرابط لمدة 24 ساعة.",

  "addr.country": "الدولة/المنطقة",
  "addr.company": "الشركة",
  "addr.phone": "الهاتف",

  "merge.title": "دمج العملاء",
  "merge.action": "دمج",
  "merge.source": "سيُدمج",
  "merge.target": "سيبقى",
  "merge.stats": "{orders} طلبات · {spent}",
  "merge.swap": "الإبقاء على العميل الآخر بدلًا من ذلك",
  "merge.choose": "اختر البيانات التي تحتفظ بها",
  "merge.field.first_name": "الاسم الأول",
  "merge.field.last_name": "اسم العائلة",
  "merge.field.email": "البريد الإلكتروني",
  "merge.field.phone": "الهاتف",
  "merge.field.locale": "اللغة",
  "merge.field.tax_exempt": "معفى من الضريبة",
  "merge.moves": "تنتقل الطلبات والعناوين والوسوم والسجل وطرق الدخول إلى العميل الباقي.",
  "merge.notes": "تُجمع الملاحظات؛ وتُملأ البيانات الفارغة من العميل الآخر.",
  "merge.consent": "يُحتفظ باشتراك التسويق إن وُجد لدى أيٍّ منهما.",
  "merge.irreversible": "سيُدمج {name}. لا يمكن التراجع عن ذلك.",
  "merge.confirm": "دمج العملاء",

  "privacy.title": "طلبات الخصوصية",
  "privacy.intro": "يمكن للعملاء طلب نسخة من بياناتهم أو حذفها. عالج الطلبات خلال 30 يومًا.",
  "privacy.none": "لا توجد طلبات هنا.",
  "privacy.kind.export": "تصدير البيانات",
  "privacy.kind.erase": "حذف البيانات",
  "privacy.status.pending": "قيد الانتظار",
  "privacy.status.processing": "قيد المعالجة",
  "privacy.status.completed": "مكتمل",
  "privacy.status.cancelled": "مرفوض",
  "privacy.status.failed": "فشل",
  "privacy.source.customer": "بطلب من العميل",
  "privacy.source.merchant": "بدأه أحد الموظفين",
  "privacy.approve": "موافقة",
  "privacy.decline": "رفض",
  "privacy.approve_export": "تصدير بيانات {name}؟",
  "privacy.approve_export_body": "سنجهز الملف ويمكنك تنزيله هنا لمدة 24 ساعة وإرساله إلى العميل.",
  "privacy.approve_erase": "حذف البيانات الشخصية لـ {name}؟",
  "privacy.approve_erase_body": "تُحذف بيانات الاتصال والعناوين والملاحظات نهائيًا. تبقى الطلبات بدون بيانات شخصية. لا يمكن التراجع.",

  "seg.title": "الشرائح",
  "seg.all": "كل الشرائح",
  "seg.intro": "تجمع الشرائح العملاء حسب سلوكهم: الطلبات والإنفاق والموقع والاشتراكات. استخدمها للخصومات والرسائل والتصدير.",
  "seg.create": "إنشاء شريحة",
  "seg.new": "شريحة جديدة",
  "seg.empty": "لا توجد شرائح بعد.",
  "seg.default": "افتراضية",
  "seg.customers": "عميل",
  "seg.default.new": "عملاء جدد",
  "seg.default.returning": "عملاء عائدون",
  "seg.default.vip": "كبار العملاء (أعلى 10٪ إنفاقًا)",
  "seg.default.at_risk": "معرّضون للفقدان",
  "seg.default.email_subscribers": "مشتركو البريد",
  "seg.default.abandoned_checkouts": "السلال المستردة (30 يوماً)",
  "seg.name": "الاسم",
  "seg.name_placeholder": "مثال: كبار عملاء الدوحة",
  "seg.query": "الشروط",
  "seg.query_hint": "اكتب الشروط أو أنشئها بالأسفل.",
  "seg.field": "الحقل",
  "seg.operator": "الشرط",
  "seg.and": "و",
  "seg.join": "الربط",
  "seg.join_and": "AND (يجب أن تتطابق كلها)",
  "seg.join_or": "OR (يكفي تطابق أي منها)",
  "seg.add_condition": "إضافة شرط",
  "seg.presets": "تواريخ سريعة",
  "seg.soon": "قريبًا",
  "seg.preview": "معاينة",
  "seg.preview_empty": "أضف شرطًا لترى من يطابق.",
  "seg.fix_query": "صحّح الشروط لترى من يطابق.",
  "seg.of_total": "من أصل {total} عميل ({pct}٪)",
  "seg.fields": "الحقول",
  "seg.fields_hint": "انقر على حقل لإضافة مثال.",
  "seg.syntax": "اجمع الشروط بـ AND وOR وNOT والأقواس. التواريخ: 2026-01-31 أو نسبية مثل ‎-30d و‎-6m. ضع النصوص بين علامتي اقتباس.",
  "seg.view_customers": "عرض العملاء",
  "seg.delete_title": "حذف هذه الشريحة؟",
  "seg.delete_body": "لا يتأثر العملاء. تتوقف الخصومات أو الحملات التي تستخدمها عن مطابقة أي أحد.",
  "seg.op.=": "يساوي",
  "seg.op.!=": "لا يساوي",
  "seg.op.>": "أكبر من",
  "seg.op.>=": "على الأقل",
  "seg.op.<": "أقل من",
  "seg.op.<=": "على الأكثر",
  "seg.op.between": "بين",
  "seg.op.contains": "يحتوي على",
  "seg.op.not_contains": "لا يحتوي على",
  "seg.op.is_null": "فارغ",
  "seg.op.is_not_null": "غير فارغ",
  "seg.rel.-7d": "قبل 7 أيام",
  "seg.rel.-30d": "قبل 30 يومًا",
  "seg.rel.-90d": "قبل 90 يومًا",
  "seg.rel.-6m": "قبل 6 أشهر",
  "seg.rel.-1y": "قبل سنة",

  "acct.accounts": "حسابات العملاء",
  "acct.mode.optional": "اختيارية",
  "acct.mode.optional_hint": "يمكن للمتسوقين الشراء كضيوف أو تسجيل الدخول.",
  "acct.mode.required": "إلزامية",
  "acct.mode.required_hint": "يجب على المتسوقين تسجيل الدخول لإتمام الشراء (مفيد لتجارة الجملة).",
  "acct.mode.disabled": "متوقفة",
  "acct.mode.disabled_hint": "لا تسجيل دخول؛ كل طلب يكون كضيف.",
  "acct.login": "طريقة تسجيل الدخول",
  "acct.method.passwordless": "رمز عبر البريد",
  "acct.method.passwordless_hint": "يتلقى المتسوقون رمزًا من 6 أرقام بالبريد. بلا كلمات مرور تُنسى.",
  "acct.method.classic": "البريد وكلمة المرور",
  "acct.method.classic_hint": "ينشئ المتسوقون كلمة مرور.",
  "acct.theme_note": "تظهر صفحات تسجيل الدخول ضمن قالب متجرك.",

  "tl.marketing": "تسويق {channel}: {state}",
  "tl.customer.created": "أُنشئ العميل",
  "tl.customer.updated": "حُدّثت بيانات العميل",
  "tl.customer.merged": "دُمج {name} في هذا العميل",
  "tl.address.added": "أُضيف عنوان",
  "tl.address.updated": "حُدّث عنوان",
  "tl.address.deleted": "حُذف عنوان",
  "tl.address.default_changed": "تغيّر العنوان الافتراضي",
  "tl.account.created": "أنشأ العميل حسابًا",
  "tl.account.signed_in": "سجّل العميل الدخول",
  "tl.account.activated": "فعّل العميل حسابه",
  "tl.account.invite_sent": "أُرسلت دعوة الحساب",
  "tl.account.invite_declined": "رفض العميل دعوة الحساب",
  "tl.account.disabled": "عُطّل الحساب",
  "tl.account.password_reset": "أعاد العميل تعيين كلمة المرور",
  "tl.account.profile_updated": "حدّث العميل ملفه",
  "tl.privacy.export_requested": "طُلب تصدير البيانات",
  "tl.privacy.erase_requested": "طُلب حذف البيانات",
  "tl.privacy.export_completed": "تصدير البيانات جاهز",
  "tl.privacy.export_failed": "فشل تصدير البيانات",
  "tl.privacy.erased": "حُذفت البيانات الشخصية",
  "cust.bulk.add_tags_title": "إضافة وسوم إلى {n} عملاء",
  "cust.bulk.remove_tags_title": "إزالة وسوم من {n} عملاء",
  "cust.bulk.delete_title": "حذف {n} عملاء؟",
  "cust.bulk.delete_body": "يتم الاحتفاظ بالعملاء الذين لديهم طلبات، امسح بياناتهم الشخصية بدلاً من ذلك. لا يمكن التراجع عن هذا.",
  "cust.bulk.done": "تم تحديث {n} عملاء",
  "cust.bulk.done_skipped": "تم تحديث {n} عملاء. تم الاحتفاظ بـ {skipped} لديهم طلبات.",
};

export default customersAr;
